import React, { memo } from 'react';
// @ts-ignore
import { getLocale } from 'umi';
import { ConfigProvider, ConfigProviderProps } from 'tea-component';
import { getTeaLocale } from '@/pages/home/utils/lang';

const TeaConfigProvider: React.FC<ConfigProviderProps> = (props) => {
  const locale = getTeaLocale(getLocale());

  return <ConfigProvider {...props} locale={locale} />;
};

export default memo(TeaConfigProvider);
